import { PlatformService } from "../../../services/platform.service";

export async function GetAccessTokenHandler(_: never, webchat: any) {
  const platformService = new PlatformService();

  switch (true) {
    case platformService.pnlUserMenuExists():
      console.debug('pnl-user-menu found. Retrieving authentication state from user-menu and sending it back to chatbot');
      if (forwardAccessTokenFromUserMenu(webchat)) {
        return;
      }
      break;
    case platformService.isAndroidEnvironment():
      console.debug('Android JavaScript interface present. Retrieve authentication state from App and sending it back to chatbot');
      if (forwardAccessTokenFromAndroid(webchat)) {
        return;
      }
      break;
    case platformService.isIosEnvironment(): {
      console.debug('iOS JavaScript interface present. Retrieve authentication state from App and sending it back to chatbot');
      if (await forwardAccessTokenFromIos(webchat)) {
        return;
      }
      break;
    }
  }

  console.error('Access token was not obtained from any platform');

  webchat.sendMessage('', {
    success: false
  });
}

export function forwardAccessTokenFromUserMenu(webchat: any) {
  registerAuthenticationResponse('onAuthenticationChange', 'web', webchat)
  window.dispatchEvent(new CustomEvent(`postnl:peekauthenticationstate`));
  return true;
}

function forwardAccessTokenFromAndroid(webchat: any) {
  const requestAccessToken = (window as any).Android?.requestAccessToken;

  if (!requestAccessToken || typeof requestAccessToken !== "function") {
    return false;
  }

  registerAuthenticationResponse('postnl:webchat:app-response', 'android', webchat);
  requestAccessToken.bind((window as any).Android)();

  return true;
}

async function forwardAccessTokenFromIos(webchat: any) {
  const requestAccessToken = (window as any).webkit?.messageHandlers?.requestAccessToken;

  if (!requestAccessToken || typeof requestAccessToken?.postMessage !== 'function') {
    return false;
  }

  registerAuthenticationResponse('postnl:webchat:app-response', 'ios', webchat);
  await requestAccessToken.postMessage.bind(requestAccessToken)('');

  return true;
}

function registerAuthenticationResponse(eventName: string, source: string, webchat: any) {
  const processAppResponse = (event: any) => {
    clearTimeout(timeout);

    webchat.sendMessage('', {
      source,
      success: true,
      accessToken: event?.detail?.access_token,
      authenticated: event?.detail?.authenticated,
    });
  };

  const timeout = setTimeout(() => {
    // Triggers a failure response after a specific amount of time, in case no response is received from the app.
    window.dispatchEvent(new CustomEvent<any>(eventName, { detail: { source, success: false } }));
  }, 3000);

  window.addEventListener(eventName, processAppResponse, {once: true});
}
